export const preventRedirectColumns: string[] = ['status', 'url', 'edit'];
